<mat-card-header class="flex align-items-center">
  <shared-title>{{ operation }} tipo de puesto de trabajo</shared-title>
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>
<form [formGroup]="workplaceTypeForm">
  <mat-dialog-content>
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Nombre'"
        [control]="$any(workplaceTypeForm.get('name'))">
      </shared-input>

      <mat-checkbox formControlName="isparking"> ¿Es parqueo? </mat-checkbox>
    </div>

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Recurrencia semanal'"
        [type]="'number'"
        [control]="$any(workplaceTypeForm.get('recurrence'))" />

      <shared-input
        class="w-full"
        [labelTitle]="'Duración por defecto'"
        [type]="'number'"
        [control]="$any(workplaceTypeForm.get('maxcapacity'))" />
    </div>

    <p>
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>Descripción</mat-label>
        <textarea
          [errorStateMatcher]="matcher"
          matInput
          formControlName="description"></textarea>
        @if (workplaceTypeForm.controls['description'].hasError('required')) {
          <mat-error>
            <small>Descripción es <strong>requerida</strong> </small>
          </mat-error>
        }
      </mat-form-field>
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'"
      >Cancelar</shared-button
    >

    <shared-button
      [disabled]="!workplaceTypeForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'"
      (click)="submit()"
      >Guardar</shared-button
    >
  </mat-dialog-actions>
</form>
